export default "__VITE_ASSET__C8Ej69u8__"